import I18n from '../../../config/i18n';

export default function staticHostData(): { sectionTitle: { related: string } } {
  return {
    sectionTitle: {
      related: I18n.t('search.more_objects'),
    },
  };
}
